import styled from 'styled-components'

import { Paper as MainPaper } from '../../../../components'

export const Paper = styled(MainPaper)`
  border: none;
  position: relative;
  z-index: 0;
`
